export default __webpack_public_path__ + "static/media/Time icon.3aac1f63.svg";